import React from "react";
import AboutPage from "./AboutPage";
import ContactPage from "./ContactPage";
import ServicePage from "./ServicePage";
import SkillPage from "./SkillPage";
import Intro from "./Intro";

const HomePage = () => {
  return (
    <>
      <Intro />
      <AboutPage />
      <ServicePage />
      <SkillPage />
      <ContactPage />
    </>
  );
};
export default HomePage;
